import { UserPayload } from "../models/SiteModel";

const URLAPI = process.env.REACT_APP_BASE_URL;

export type LogisticaHoja = {
  idHojaRuta: number;
  fecha: string;
  transportista: string;
  estado: number;
};

export type LogisticaParada = {
  idEnvio: number;
  orden: number;
  cliente: string;
  comprobante: string;
  domicilio: string;
  estado: number;
  total: number;
  formaPagoOriginal?: string;
  requiereCobroManual?: boolean;
  totalCobrado?: number;
  saldoPendiente?: number;
  confirmada?: boolean;
};

async function request(user: UserPayload, path: string, init: RequestInit = {}) {
  const response = await fetch(`${URLAPI}/Logistica/${path}`, {
    ...init,
    headers: { "Content-Type": "application/json", Authorization: `Bearer ${user.token}`, ...(init.headers ?? {}) },
  });
  if (!response.ok) {
    const raw = await response.text();
    let message = raw || response.statusText;
    try {
      const payload = JSON.parse(raw);
      const errors = payload?.errors ? Object.values(payload.errors).flat().join(" ") : "";
      message = payload?.detail || errors || payload?.title || message;
    } catch { /* respuesta no JSON */ }
    throw new Error(message);
  }
  if (response.status === 204) return undefined;

  const body = await response.text();
  return body.trim() ? JSON.parse(body) : undefined;
}

export const obtenerMisHojas = (user: UserPayload) => request(user, "MisHojas") as Promise<LogisticaHoja[]>;
export const obtenerParadas = (user: UserPayload, idHojaRuta: number) => request(user, `Hojas/${idHojaRuta}/Paradas`) as Promise<LogisticaParada[]>;
export const obtenerFormasPago = (user: UserPayload, idHojaRuta: number) => request(user, `Hojas/${idHojaRuta}/FormasPago`) as Promise<{ formaPago: string }[]>;
export type LogisticaLinea = { idEnvio: number; tipoOperacion: number; idLinea: number; idProducto: number; producto: string; cantidadSolicitada: number; cantidadEntregada?: number | null; cantidadNoEntregada?: number | null; motivo?: string; confirmada?: boolean };
export const obtenerLineas = (user: UserPayload, idEnvio: number) => request(user, `Envios/${idEnvio}/Lineas`) as Promise<LogisticaLinea[]>;
export type ConfirmarEntregaCommand = { idHojaRuta: number; estado: number; motivoGeneral?: string; motivoCobroParcial?: string; motivoCobranza?: string; tokenOperacion: string; lineas: { tipoOperacion: number; idLinea: number; cantidadEntregada: number; motivo?: string }[]; cobro?: { formaPago: string; importe: number; referencia?: string; banco?: string; fotoBase64?: string; fotoMime?: string } };
export const confirmarEntrega = (user: UserPayload, idEnvio: number, command: ConfirmarEntregaCommand) => request(user, `Envios/${idEnvio}/ConfirmarEntrega`, { method: "POST", body: JSON.stringify(command) });
export const finalizarHoja = async (user: UserPayload, idHojaRuta: number): Promise<void> => {
  await request(user, `Hojas/${idHojaRuta}/Finalizar`, { method: "POST" });
};
export const registrarCobro = (user: UserPayload, command: { idEnvio: number; idHojaRuta: number; formaPago: string; importe: number; observacion?: string; fotoBase64?: string; fotoMime?: string; referencia?: string; banco?: string }) =>
  request(user, "Cobros", { method: "POST", body: JSON.stringify(command) });
export const cambiarEstado = (user: UserPayload, idEnvio: number, command: { idHojaRuta: number; estado: number; observacion?: string }) =>
  request(user, `Envios/${idEnvio}/Estado`, { method: "POST", body: JSON.stringify(command) });
export const registrarEntregaDetalle = (user: UserPayload, idEnvio: number, command: { idHojaRuta: number; tipoOperacion: number; idLinea: number; idProducto: number; cantidadPedida: number; cantidadEntregada: number; motivo?: string }) =>
  request(user, `Envios/${idEnvio}/Entrega`, { method: "POST", body: JSON.stringify(command) });
